export function trackAdroll(event = 'pageView') {
  if (!window.adroll || !window.adroll.track) {
    return;
  }
  window.adroll.track(event, { segment_name: '97f45b70' });
}
